<div style="width: 100%; margin-bottom: 20px;" class="layout horizontal center middle">
  <ul *ngIf="routingDataService.currentBreadcrumbs" class="breadcrumb">
      <!--
      DAL SECONDO ELEMENTO IN POI
      -->
      <li *ngFor="let node of routingDataService.currentBreadcrumbs.slice(1).reverse(); let i = index"
          [ngStyle]="{'background-color': appearance.breadcrumbs.borderColor}"
          (mouseover)="hover[i] = (node.navigable && i!=0) ? true : false" 
          (mouseleave)="hover[i]=false"
          (click)="breadcrumbClick(node)">
        <div class="layout horizontal left middle;"
             [ngStyle]="{
               'background-color': hover[i] ? appearance.breadcrumbs.hoverBgColor : appearance.breadcrumbs.bgColor,
               'color': hover[i] ? appearance.breadcrumbs.hoverFontColor : appearance.breadcrumbs.fontColor,
               'cursor':hover[i] ?'pointer' : null
             }">
          <span style="padding-inline-end: 5px;"></span>
          <span class="node">
            <app-icon-label [iconId]="node.icon" 
                            [label]="node.label | translate">
            </app-icon-label>
          </span>
          <span style="padding-inline-end: 40px;"></span>
        </div>
      </li>
      <!--
      PRIMO ELEMENTO
      -->
      <li [ngStyle]="{'background-color': appearance.breadcrumbs.borderColor}"
          (mouseover)="firstElementHover = (routingDataService.currentBreadcrumbs[0].navigable && routingDataService.currentBreadcrumbs.length!=1) ? true : false" 
          (mouseleave)="firstElementHover=false"
          (click)="breadcrumbClick(routingDataService.currentBreadcrumbs[0])">
        <div [ngStyle]="{
               'background-color': firstElementHover ? appearance.breadcrumbs.hoverBgColor : appearance.breadcrumbs.bgColor,
               'color': firstElementHover ? appearance.breadcrumbs.hoverFontColor : appearance.breadcrumbs.fontColor,
               'cursor':firstElementHover ?'pointer' : null
             }">
          <span class="node">
            <app-icon-label [iconId]="routingDataService.currentBreadcrumbs[0].icon" 
                            [label]="routingDataService.currentBreadcrumbs[0].label | translate">
            </app-icon-label>
          </span>
          <span style="padding-inline-end: 40px;"></span>
        </div>
      </li>
  </ul>
</div>


